module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/axios/index.js
// module id = 231
// module chunks = 0 1 2 3 5 6 7 8 9 10 11